import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationStateService {
  private restoreStateSubject = new BehaviorSubject<boolean>(false);
  restoreState$ = this.restoreStateSubject.asObservable();

  private updateUrlSubject = new BehaviorSubject<string | null>(null);
  updateUrl$ = this.updateUrlSubject.asObservable();

  triggerRestoreState() {
    this.restoreStateSubject.next(true);
  }

  triggerUpdateUrl(url: string) {
    console.log('triggerUpdateUrl', url);
    this.updateUrlSubject.next(url);
  }
}